import React from 'react'
import { Button } from "react-bootstrap"
import "./styles/LoginFailed.styles.scss"
import LoginError from "../../../resources/loginError.png" 

const baseURL = process.env.REACT_APP_BASE_URL

const LoginFailed = () => {
  return (
    <div>
      <main>
        <div className="main-wrapper">
          <picture className="scarecrow-img">
            <img src={LoginError} alt="scarecrow" />
          </picture>
          <div className="error-text">
            <h2>Login Failed: Invalid Grant</h2>
            <p>Please Try Again</p>
            <Button
              onClick={() => {
                window.location.href = baseURL+"/login"
              }}
            >
              Back to Login
            </Button>
          </div>
        </div>
      </main>
    </div>
  )
}

export default LoginFailed